// extracted by mini-css-extract-plugin
module.exports = {"wrap":"bc","heading":"cc","brandPromo":"dc"};